import { SectionContainer } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React, { useCallback, useMemo } from 'react';

import {
  defaultFinancialAnalysisType,
  FinancialAnalysisType,
  financialAnalysisTypeList,
  financialAnalysisTypes,
  financialAnalysisTypesLabels,
} from './constants';

export namespace FinancialAnalysisTypes {
  export interface Props {
    isMobile?: boolean;
  }
}

export const FinancialAnalysis: React.FC<FinancialAnalysisTypes.Props> = ({ isMobile }) => {
  const [currentType, setCurrentType] = React.useState<FinancialAnalysisType>(
    defaultFinancialAnalysisType
  );

  const handleSetCurrentType = useCallback((type: string) => {
    setCurrentType(type as FinancialAnalysisType);
  }, []);

  const normalizedFinancialAnalysisTypes = useMemo(() => {
    return financialAnalysisTypeList.map((type) => ({
      label: financialAnalysisTypesLabels[type],
      value: type,
    }));
  }, []);

  const Component = useMemo(() => financialAnalysisTypes[currentType], [currentType]);

  return (
    <SectionContainer
      withSeparator={!isMobile}
      title="ANÁLISE FINANCEIRA"
      marginX={Spacing['stack.xxxs']}
      withFilter
      filterOptions={normalizedFinancialAnalysisTypes}
      selectedOption={currentType}
      onFilterChange={handleSetCurrentType}
      multipleFilterLabel="Selecione uma opção">
      <Component isMobile={isMobile} />
    </SectionContainer>
  );
};
